<template>
    <div id="search-container" class="search-container">
      <div class="gcse-search"></div>
    </div>
</template>

<script>
export default {
  name: 'Search',
  mounted() {
      let searchScript = document.createElement('script')
      searchScript.setAttribute('src', 'https://cse.google.com/cse.js?cx=017610327623058857991:fkbw5jdydmu')
      document.getElementById('search-container').appendChild(searchScript)
  }
}
</script>
<style lang="scss">
#___gcse_0 
{
  max-width: 400px;
  margin: 0 auto;
  
  .gsc-control-cse {
    padding: 0;
    border: none;
    background-color: transparent !important;
  }
  .gsc-input {
    color: #fff;
    padding: 0;
    margin: 0;
    min-width: 278px;
  }
  .gsc-input-box {
    border-color: #fff;
    border-radius: 0;
    background-color: transparent;
  }
  .gsib_a {
    padding: 8px !important;
  }

  td.gsc-search-button { 
  }
  button.gsc-search-button {
    position: relative;
    right: 50px;
    width: 49px;
    height: 35px;
    padding: 0;
    margin-left: 0;
    border: none;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .gsst_b {
    position: relative;
    right: -30px;
  }
  .gscb_a {
    color: #eee;
  }
}
  
</style>
